export default __webpack_public_path__ + "static/media/cursor.fa570d75.svg";